import React, { useState, useRef } from "react";
import DropdownWrapper from "../dropdown/DropdownWrapper";
import ExperienceDropdown, { IExperienceValues } from "./ExperienceDropdown";
import Chip from "../Chip";

interface IProps {
  setSelectedExp: React.Dispatch<React.SetStateAction<IExperienceValues>>;
  selectedExp: IExperienceValues;
  handleDropdownOpen: (open: boolean) => void;
  isActive?: boolean;
  hasActiveField?: boolean;
  handleFieldActive: (field: 'keywords' | 'location' | 'exp' | null) => void;
}

const Experience: React.FC<IProps> = ({ 
  setSelectedExp, 
  selectedExp, 
  handleDropdownOpen,
  isActive = false,
  hasActiveField = false,
  handleFieldActive,
}) => {
  const [showDropdown, setShowDropdown] = useState<boolean>(false);
  const wrapperRef = useRef<HTMLDivElement>(null);


  const handleSelect = (value: string, type: "min" | "max") => {
    if (type === "min") {
      setSelectedExp({ ...selectedExp, min: value });
    } else {
      setSelectedExp({ ...selectedExp, max: value });
    }
  };

  const handleDelete = (type: "min" | "max") => {
    if (type === "min") {
      setSelectedExp({ ...selectedExp, min: "" });
    } else {
      setSelectedExp({ ...selectedExp, max: "" });
    }
  };

  const handleClick = () => {   
    if(!showDropdown){
      handleDropdownOpen(true);
      handleFieldActive('exp');
    } else {
      handleFieldActive(null);
    }
    setShowDropdown(prev => !prev);
  }

  const handleCloseDropdown = () => {
    setShowDropdown(false);
    handleFieldActive(null);
  }

  const className = `qs_search_input_sec experience${isActive ? ' active' : hasActiveField ? ' inactive' : ''}`;

  return (
    <div className={className} ref={wrapperRef}>
       
      <div className="qsSprite icons experience" />

      <div
        className="qs_search_input qs_align_center_vertical"
        onClick={handleClick}
      >
        {selectedExp.min || selectedExp.max ? (
          <div className="qs_search_chips">
            {selectedExp.min && (
              <Chip
                chipDetails={{
                  text: `Min: ${selectedExp.min}`,
                  id: selectedExp.min,
                }}
                onDelete={() => handleDelete("min")}
                onTextClick={handleClick}
              />
            )}
            {selectedExp.max && (
              <Chip
                chipDetails={{
                  text: `Max: ${selectedExp.max}`,
                  id: selectedExp.max,
                }}
                onDelete={() => handleDelete("max")}
                onTextClick={handleClick}
              />
            )}
          </div>
        ) : (
          <span className="placeholder">Experience</span>
        )}
      </div>

      <DropdownWrapper
        classNames="qs_exp_dd_wrapper"
        isOpen={showDropdown}
        handleClose={handleCloseDropdown}
        containerRef={wrapperRef}
        handleFieldActive={handleFieldActive}
      >
        <ExperienceDropdown onSelect={handleSelect} selectedExp={selectedExp} />
      </DropdownWrapper>
    </div> 
  );
};

export default React.memo(Experience);
